import { RequestHelper,IResponse,IResponseWithData } from "../libs/request-helper";
import { MagazineEntryDto } from "../dtos/magazine-entry-dto";
import { MagazineReuestDto } from "../dtos/magazine-request-dto";
import { MagazineResponseDto } from "../dtos/magazine-response-dto";
import {Utils} from "../utils";
import {InfiniteScrollHelper} from "../libs/infinite-scroll-helper";
import {ErrorRenderer} from "../renderer/error-renderer";
import {DeviderRenderer} from "../renderer/devider-renderer"
import {ItemRender} from "../renderer/magazine/item-renderer"
import {FilterBarDock} from "../filter-bar-dock";
import {ImageOverlayHelper} from "../libs/image-overlay-helper";
declare var Hyphenator:any;


export class Magazine{
	protected static REQUEST_URL = "/wp-content/themes/enfold-schauspielhaus/json/magazine.php";
	protected static ERROR_MSG = "Es konnten leider keine Magazineinträge gefunden werden!";

	protected static dataContainer: HTMLElement;
	protected static mainContainer: HTMLElement;
	protected static request:MagazineReuestDto;
	protected static lastDate: Date|null;
	protected static errorRenderer: ErrorRenderer;
	protected static deviderRenderer:DeviderRenderer;
	protected static itemRenderer: ItemRender;

	protected static async init():Promise<void> {
		var filterBar = document.getElementById("filterBar");
		var mainMenu = document.getElementById("nav_mainMenuWrapper");
		if(filterBar != null && mainMenu != null){
			FilterBarDock.filterBarBottomPosition = mainMenu.offsetTop + mainMenu.clientHeight + filterBar.clientHeight;;
		}

		Magazine.lastDate = null;
		Magazine.dataContainer = <HTMLElement>document.getElementById("p_magazineData");
		Magazine.mainContainer = <HTMLElement>document.getElementsByTagName("main").item(0);
		Magazine.errorRenderer = new ErrorRenderer(Magazine.dataContainer,Magazine.ERROR_MSG);
		Magazine.deviderRenderer = new DeviderRenderer(Magazine.dataContainer);
		document.addEventListener('DOMContentLoaded', Magazine.onDocumentLoaded, false);
		Magazine.request = {};
	}
	protected static onDocumentLoaded() {
		FilterBarDock.initOnLoaded(
			<HTMLElement>document.getElementsByClassName("monthMedium").item(0),
			Magazine.filterChangedCallback);
		InfiniteScrollHelper.init(
			Magazine.mainContainer,
			Magazine.dataContainer,
			Magazine.responseCallback,
			Magazine.request,
			Magazine.REQUEST_URL);
	}

	protected static filterChangedCallback(typeId:any,seasonId:any){
		Magazine.lastDate = null;
		Magazine.request.typeId = typeId;
		Magazine.request.seasonId = seasonId;
		Magazine.request.lastEntrieDate = undefined;
		InfiniteScrollHelper.reInit(Magazine.request);
	}
	
	protected static responseCallback(res: IResponse):boolean{
		if(Magazine.request.lastEntrieDate == undefined){
			Magazine.request.lastEntrieDate = new Date();
		}
		if(!res.requestError){
			var response = <IResponseWithData<MagazineResponseDto>>res;
			var responseDto = <MagazineResponseDto>response.data;
			if(responseDto.entries.length > 0){
				var data = responseDto.entries;
				Magazine.request.lastEntrieDate = new Date(data[data.length - 1].date);
				InfiniteScrollHelper.setRequestDto(Magazine.request);
				Magazine.appendData(data);
			}else if(responseDto.entries.length === 0 && responseDto.isMoreDataAvailable){
				if(Magazine.request.lastEntrieDate != null){
					var date = Magazine.request.lastEntrieDate;
					date.setMonth(date.getMonth() - 1);
					Magazine.request.lastEntrieDate = date;
					InfiniteScrollHelper.setRequestDto(Magazine.request);
				}
			}
			ImageOverlayHelper.init();
			if(responseDto.isMoreDataAvailable){
				return true;
			}else{
				return false;
			}
		}else{
			FilterBarDock.checkDeviderForFilterBar();
			Magazine.errorRenderer.render();
			return false;
		}
	}

	protected static appendData(data: MagazineEntryDto[]){
		if(data.length > 0){
			var currentDate = new Date(data[0].date);
			var monthContainer = document.createElement("div");
			monthContainer.classList.add("_monthContainer");
			if(Magazine.lastDate === null){
				Magazine.renderDivider(currentDate,false);
			}else if(Magazine.lastDate.getMonth() !== currentDate.getMonth()){
				Magazine.renderDivider(currentDate,true);
			}
			Magazine.dataContainer.appendChild(monthContainer);
			Magazine.itemRenderer = new ItemRender(monthContainer);
			for(var i = 0; i < data.length; i++){
				Magazine.lastDate = currentDate;
				Magazine.itemRenderer.render(data[i]);
			}
		}
		FilterBarDock.devider =  document.getElementsByClassName("_monthDevider");
		FilterBarDock.checkDeviderForFilterBar();
		Hyphenator.run();
	}

	protected static renderDivider(date:Date,shouldDisplay:boolean){
		Magazine.deviderRenderer.render(date,shouldDisplay);
	}


}